import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'expenses',
  standalone: false
})
export class ExpensesPipe implements PipeTransform {

  transform(items: any[], filter: { pendentPaid?: boolean; }, isGeneralExpense: boolean): any[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.pendentPaid) {
      const key = isGeneralExpense ? 'datos.pagado' : 'pagado';
      items = items.filter((item) => !key.split('.').reduce((acc, key) => acc[key], item));
    }

    return items;

  }

}
